<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    <div class="card">
      <h4 class="card-header">Send feedback</h4>
      <div class="card-body col-md-8">
        <p>Send suggestions to improve the web app:</p>
        <textarea class="form-control mb-3"
                  rows="8"
                  [(ngModel)]="feedback"
                  placeholder="I have a question...&#10;I suggest to... &#10;It would be nice to...&#10;The app is missing this...&#10;I think I found a bug..."></textarea>
        <button class="btn btn-primary" (click)="addFeedback()" [disabled]="!feedback">
          <i class="fa fa-paper-plane"></i> Send
        </button>
      </div>
    </div>
  </div>
</div>